import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '电视剧', path: '/category/dianshiju' },
    { label: '电影', path: '/category/dianying' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '动漫', path: '/category/dongman' },
    { label: '纪录片', path: '/category/jilupian' },
    { label: '短视频', path: '/category/duanshipin' },
  ],
  平台服务: [
    { label: '关于我们', path: '/about' },
    { label: '用户协议', path: '/article/a2' },
    { label: '隐私政策', path: '/article/a1' },
    { label: '版权声明', path: '/article/a2' },
    { label: '帮助中心', path: '/article/a3' },
    { label: '意见反馈', path: '/about' },
  ],
  热门推荐: [
    { label: '庆余年 第三季', path: '/category/dianshiju' },
    { label: '流浪地球3', path: '/category/dianying' },
    { label: '奔跑吧兄弟', path: '/category/zongyi' },
    { label: '斗罗大陆', path: '/category/dongman' },
    { label: '舌尖上的中国', path: '/category/jilupian' },
    { label: '搞笑短视频合集', path: '/category/duanshipin' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-[1280px] mx-auto">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-xl text-white"></i>
              </div>
              <span className="font-heading text-xl text-white">黄瓜视频</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              黄瓜视频在线——免费高清视频在线播放平台。海量正版内容，多终端畅享，无需下载，随时随地免费观看。追剧、看电影、看综艺、看动漫的首选平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-white text-sm mb-4">
                <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">{title}</a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 max-w-[1280px] mx-auto">
            <p className="text-xs text-foreground-500">
              &copy; 2026 黄瓜视频在线 huangguaTV.com 版权所有 | ICP备案号：京ICP备2024000001号
            </p>
            <p className="text-xs text-foreground-500">
              违法和不良信息举报电话：400-000-0000 | 举报邮箱：jubao@huangguaTV.com
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}